import type { HTMLProps, ReactNode } from 'react';
import { IoHelpCircle, IoWarning } from 'react-icons/io5';
import { FuuzeColors } from '../../styles/colors.js';
import { FlexRow } from '../fuuze-flex.js';

type FuuzeTooltipDefaultTriggerProps = {
  text: string | ReactNode;
  hideHelpIcon?: boolean;
  severity?: 'warning' | 'default';
} & HTMLProps<HTMLDivElement>;

export function FuuzeTooltipDefaultTrigger({
  text,
  hideHelpIcon,
  severity,
  ...props
}: FuuzeTooltipDefaultTriggerProps) {
  return (
    <FlexRow
      {...props}
      style={{
        gap: 4,
        alignItems: 'center',
        borderBottom: `1px dashed ${severity === 'warning' ? FuuzeColors.orange.orange80 : FuuzeColors.dark.dark700}`,
        width: 'fit-content',
        cursor: 'help',
        ...props.style,
      }}
    >
      {hideHelpIcon ? (
        text
      ) : (
        <>
          {text && <span>{text}</span>}
          {!hideHelpIcon && severity === 'warning' ? (
            <IoWarning size={20} fill={FuuzeColors.orange.orange80} />
          ) : (
            <IoHelpCircle size={20} />
          )}
        </>
      )}
    </FlexRow>
  );
}
